export const phieuNhapKho = {
  sections: {
    list: { title: '入库单' },
    detail: { title: '入库单详情' },
    lines: '明细',
  },
  titles: { add: '新增', addNew: '新增' },
  columns: {
    tongSoLuong: '总数量',
    summary: '概要',
    status: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    code: '单号',
    chiNhanh: '门店',
    loaiPhieu: '类型',
    ngayChungTu: '凭证日期',
    nhaCungCap: '供应商',
    khachHang: '客户',
    chiNhanhDoi: '对应分支',
    trangThai: '状态',
    tongTienHang: '货品金额',
    phieuTraNguon: '来源退货单',
    maHoaDon: '发票号',
  },
  placeholders: {
    toolbarSearch: '搜索',
    maLoRequired: '必填（效期管理商品）',
    maLoOptional: '非批次管理可留空',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  fields: {
    code: '单号',
    chiNhanh: '门店',
    loaiPhieu: '类型',
    ngayChungTu: '凭证日期',
    nhaCungCap: '供应商',
    khachHang: '客户',
    chiNhanhDoi: '对应分支',
    lyDo: '事由',
    ghiChu: '备注',
    phieuChuyen: '调拨单',
    status: '状态',
    totalAmount: '货品金额',
    giamGiaPhieu: '整单折扣',
    tongSauGiamGia: '应付金额',
    product: '商品',
    productCode: '编码',
    productName: '名称',
    productSearch: '搜索商品',
    qty: '数量',
    unitPrice: '单价',
    donGiaMua: '采购单价',
    donGiaVon: '成本单价',
    donViTinhMua: '采购单位',
    maSp: '商品编码',
    tenSp: '商品名称',
    hinhThucVc: '运输方式',
    cont: '柜号',
    maVanChuyenNcc: '供应商运单号',
    maVanChuyenAzl: 'AZL运单号',
    maYcmh: '采购申请号',
    maBaoGia: '报价单号',
    giamGia: '折扣',
    maLo: 'Serial/IMEI',
    hanSuDung: '产品日期',
    serialImei: 'Serial/IMEI',
    dateSanPham: '产品日期',
    lineAmount: '行金额',
    lineGhiChu: '行备注',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  loaiPhieu: {
    NHAP_MUA: '采购入库',
    NHAP_CHUYEN: '调入',
    NHAP_TRA_HANG: '退货入库',
    NHAP_DIEU_CHINH: '入库调整',
    NHAP_KHAC: '其他入库',
    KIEM_KE: '盘点',
  },
  detailTabs: {
    chung: '总览',
    generalInfo: '信息',
    chiTietHang: '明细',
    lines: '明细',
  },
  form: {
    loaiPhieu: '类型',
    maPhieu: '单号',
    maPhieuAuto: '保存时自动生成',
    ngayChungTu: '凭证日期',
    nhaCungCap: '供应商',
    khachHang: '客户',
    chiNhanhDoi: '对应分支',
    lyDo: '事由',
    ghiChu: '单据备注',
    note: '单据备注',
    sectionHeader: '基本信息',
    sectionLines: '明细',
    sectionSummary: '汇总',
    product: '商品',
    productSearch: '搜索编码/名称',
    qty: '数量',
    unitPrice: '单价',
    donGiaMua: '采购单价',
    donGiaVon: '成本单价',
    donViTinhMua: '采购单位',
    maSp: '商品编码',
    tenSp: '商品名称',
    hinhThucVc: '运输方式',
    cont: '柜号',
    maVanChuyenNcc: '供应商运单号',
    maVanChuyenAzl: 'AZL运单号',
    maYcmh: '采购申请号',
    maBaoGia: '报价单号',
    giamGia: '折扣',
    giamGiaPhieu: '整单折扣',
    tongSauGiamGia: '应付金额',
    maLo: 'Serial/IMEI',
    hanSuDung: '产品日期',
    serialImei: 'Serial/IMEI',
    dateSanPham: '产品日期',
    lineNote: '行备注',
    lineAmount: '行金额',
    tongTienHang: '货品金额',
    tongSoMatHang: '品项数',
    tongSoLuong: '总数量',
    lineCount: '{count} 行',
    emptyAddProduct: '在上方搜索并选择商品以添加明细。',
    emptyAddProductPos: '在蓝色栏输入编码/名称（F3）添加明细。',
    save: '保存',
    lotRequired: '批次号必填（效期管理）',
    expiryRequired: '有效期必填（效期管理）',
  },
  status: {
    phieuTam: '草稿',
    cho: '待处理',
    daHoanThanh: '已入库',
    daHuy: '已取消',
  },
  filter: {
    title: '筛选',
    loaiPhieu: '类型',
    trangThai: '状态',
    nhaCungCap: '供应商',
    tuNgay: '起始日期',
    denNgay: '结束日期',
    fromDate: '起始日期',
    toDate: '结束日期',
    dateRangePlaceholder: '选择日期范围',
    all: '全部',
    reset: '重置',
    sortDir: '排序',
    asc: '升序',
    desc: '降序',
    advancedTitle: '高级筛选',
    nccTreeAll: '全部供应商',
    nccTreeSearch: '搜索供应商',
    nccTreeEmpty: '暂无供应商',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
  },
  actions: {
    complete: '完成',
    cancelVoucher: '取消单据',
    copy: '复制单据',
    addLine: '添加空行',
    importExcel: '导入 Excel',
    downloadTemplate: '下载模板',
    dongY: '同意',
  },
  messages: {
    importDescription:
      '下载模板（* = 必填，与手工录入一致）。填写明细；按类型在下方选择供应商/对应分支。一个文件 = 一张草稿。',
    importSuccess: '已从 Excel 导入商品。',
    importWillCreate: '将从 {count} 行商品创建 1 张入库单。',
    importPreviewProgress: '预览入库单',
    importPreviewLoading: '正在准备入库单…',
    importPreviewDone: '已通过预览创建入库单。',
    importChiNhanhNhan: '收货分支（当前）',
    importChiNhanhChuyen: '发货分支（对应）',
    importNeedNcc: '采购入库必须选择供应商。',
    importNeedChiNhanhDoi: '调拨入库必须选择发货（对应）分支。',
    loadError: '加载入库单失败。',
    noData: '暂无入库单。',
    listSummary: '共计：{count}',
    createSuccess: '已创建入库单并增加库存。',
    updateSuccess: '已更新入库单。',
    deleteSuccess: '已删除入库单。',
    needLines: '请至少添加一行明细。',
    needNgayChungTu: '请先选择凭证日期。',
    validateNgayChungTuBeforeNgayTao: '凭证日期无效。',
    needNhaCungCap: '请先选择供应商。',
    needChiNhanhDoi: '请先选择对应分支。',
    nhapTraHangBlocked: '不能在此创建退货入库单。退货入库须从销售退货单创建（需同时有成本价与售价）。',
    needMaSp: '请填写每行商品编码。',
    needTenSp: '请填写每行商品名称。',
    needSoLuong: '请填写每行数量（> 0）。',
    needDonViTinhMua: '请填写每行采购单位。',
    needMaLo: '请为 {code} 填写批次号。',
    needHanSuDung: '请为 {code} 填写有效期。',
    giamGiaVuotDonGia: '{code} 的折扣不能大于单价。',
    soKhongDuocAm: '数量、单价和折扣不能为负数。',
    completeSuccess: '入库单已完成。',
    cancelVoucherSuccess: '入库单已取消。',
    notFound: '未找到单据。',
    noLines: '暂无明细。',
    loadingLines: '正在加载明细…',
    confirmDelete: '删除 {name}？',
    confirmComplete: '完成单据 {name}？库存将被更新。',
    confirmCancelVoucher: '取消单据 {name}？已入库的库存将被扣回。此操作无法撤销。',
  },
}
